export default __webpack_public_path__ + "static/media/MurugappaTitleImage.543c460d.png";